import PropTypes from "prop-types";
import React from "react";
// import { withRouter, matchPath } from "react-router";
import RouteParser from "route-parser";

import ReactHtmlParser from "react-html-parser";

// ^^ A Link element for our custom history router.

import Form, { FormRow, SubmitButton } from "../../../../components/Form";

import PopupPageDecoration from "../../../../views/HomeView/PopupPages/PopupPageDecoration";

import PageFooter from "../../../../components/PageFooter";

import FormElement from "../../../../components/Form/FormElement";

import * as ROUTES from "../../../../constants/routes.js";

import "./style.scss";

class RolePage extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      submitting: false,
      contentReady: false,
      applyForRoleValues: {},
      formComplete: false,
    };

    this.vars = {};
  }

  componentDidMount() {
    // this.timerID = setInterval(() => this.tick(), 1000);

    this.init();
  }

  componentWillUnmount() {
    // clearInterval(this.timerID);
  }

  componentDidUpdate(prevProps) {
    var Z = this;
    if (this.props.currentRoute !== prevProps.currentRoute) {
      Z.getRoleData();
    }
  }

  init = () => {
    const Z = this;

    Z.getRoleData();
  };

  getJobId = () => {
    const route = new RouteParser(ROUTES.CAREERS_ROLE);
    const routeParams = route.match(window.location.pathname);

    if (routeParams) {
      return routeParams.roleId;
    }

    return null;
  };

  getRoleData = async () => {
    const Z = this;

    if (Z.props.setReady != null) {
      Z.props.setReady(false);
    }
    Z.setState({
      contentReady: false,
    });

    const jobId = this.getJobId();

    if (jobId) {
      const url = `https://boards-api.greenhouse.io/v1/boards/mediaartslab/jobs/${jobId}?questions=true`;
      const response = await fetch(url);
      const job = await response.json();

      Z.setState(
        {
          contentReady: true,
          roleLocation:
            job.location.name === "All Locations"
              ? "Get in touch"
              : job.location.name,
          roleTitle:
            job.location.name === "All Locations" ? "Apply Here" : job.title,
          roleDescription: job.content,
          questions: job.questions,
        },
        () => {
          if (Z.props.setReady != null) {
            Z.props.setReady(Z.props.componentRoute, true);
          }
        },
      );
    }
  };

  submitApplication = async () => {
    const Z = this;

    Z.setState({ submitting: true });

    const values = this.state.applyForRoleValues;
    const formData = new FormData();

    Object.entries(values).forEach(([key, value]) => {
      if (value) {
        formData.append(key, value);
      }
    });

    const sendRequest = async () => {
      const jobId = this.getJobId();
      const url = `https://gmyy5dtym2.execute-api.us-east-1.amazonaws.com/production/api/submit?id=${jobId}`;

      const response = await fetch(url, {
        method: "post",
        body: formData,
      });

      const responseJson = await response.json();
      return responseJson;
    };

    const setResponse = (response) => {
      var nextPage;
      if (response.success) {
        nextPage = ROUTES.CAREERS_THANK_YOU;
        Z.props.setFormError(null);
      } else {
        nextPage = ROUTES.CAREERS_SUBMISSION_ERROR;
        Z.props.setFormError({
          status: response.status,
          error: response.error,
        });
      }

      var newHistoryState = {};
      var newHistoryTitle = "";
      window.history.pushState(newHistoryState, newHistoryTitle, nextPage);

      var popStateEvent = new PopStateEvent("popstate", {
        state: newHistoryState,
      });
      window.dispatchEvent(popStateEvent);
    };

    const response = await sendRequest();

    Z.setState({ submitting: false }, () => {
      setResponse(response);
    });
  };

  getTextFromHtml = (s) => {
    var span = document.createElement("span");
    span.innerHTML = s;
    return span.textContent || span.innerText;
  };

  render() {
    var Z = this;

    const rDescription = ReactHtmlParser(
      ReactHtmlParser(Z.state.roleDescription),
    );

    const descText = Z.getTextFromHtml(
      ReactHtmlParser(Z.state.roleDescription),
    );

    return (
      <PopupPageDecoration isVertical={true}>
        <div className={`RolePage`}>
          <div className="page-title-row">
            <div className="page-title-location">{Z.state.roleLocation}</div>
            <div className="page-title">{Z.state.roleTitle}</div>
          </div>
          {descText.length >= 8 ? (
            <div className="page-description">{rDescription}</div>
          ) : (
            <div className="spacer" style={{ height: "32px" }}></div>
          )}
          <div className="page-apply-section">
            <div className="page-h2">Apply for this role</div>
            {Z.state.questions && (
              <Form
                className="role-apply-form"
                onChange={({ values }) => {
                  Z.setState({ applyForRoleValues: values });
                }}
              >
                {Z.state.questions.map((question, questionIndex) => {
                  return (
                    <FormRow key={questionIndex}>
                      <FormElement question={question} />
                    </FormRow>
                  );
                })}
                <FormRow style={{ marginTop: "32px" }}>
                  <SubmitButton
                    title="Submit Application"
                    action={Z.submitApplication}
                    submitting={Z.state.submitting}
                  />
                </FormRow>
              </Form>
            )}
          </div>
          <div className="page-bottom-space"></div>
          <PageFooter />
        </div>
      </PopupPageDecoration>
    );
  }
}

RolePage.propTypes = {
  componentRoute: PropTypes.string,
  currentRoute: PropTypes.object,
  setReady: PropTypes.func,
  setFormError: PropTypes.func,
};

export default RolePage;
